<template>
	<form class="report">
		<h2 class="text-center mb-2">Download Report</h2>
		<label>Start Date</label>
		<datepicker
			placeholder="Select a date"
			inputClass="datepicker-input"
			v-model="beginDate"
			:format="customFormatter"
			@closed="closeBeginDateDatePicker"
		/>
		<p class="errorMsg" v-if="validationErrors.beginDate">
			{{ validationErrors.beginDate }}
		</p>
		<label>End Date</label>
		<datepicker
			placeholder="Select a date"
			inputClass="datepicker-input"
			v-model="endDate"
			:format="customFormatter"
			@closed="closeEndDateDatePicker"
		/>
		<p class="errorMsg" v-if="validationErrors.endDate">
			{{ validationErrors.endDate }}
		</p>
		<div class="text-right">
			<mdb-btn
				@click.native.prevent="createReport"
				class="btn-color-primary"
				>Create Report</mdb-btn
			>
		</div>
	</form>
</template>

<script>
import { mdbBtn } from 'mdbvue'
import Datepicker from 'vuejs-datepicker'
import * as yup from 'yup'
import moment from 'moment'
import { getValidationErrors } from '@/utils/Help.js'
import NProgress from 'nprogress'
import { saveAs } from 'file-saver'

const schema = yup.object().shape({
	beginDate: yup
		.string()
		.label('Begin Date')
		.required("Begin Date can't be empty."),
	endDate: yup
		.string()
		.label('End Date')
		.required("End Date can't be empty.")
})

export default {
	name: 'Report',
	data() {
		return {
			beginDate: '',
			endDate: '',
			validationErrors: {}
		}
	},
	components: {
		mdbBtn,
		Datepicker
	},
	methods: {
		customFormatter(date) {
			return moment(date).format('D MMMM YYYY')
		},
		closeCustomFormatter(date) {
			return moment(date).format()
		},
		closeBeginDateDatePicker() {
			this.beginDate = this.closeCustomFormatter(this.beginDate)
		},
		closeEndDateDatePicker() {
			this.endDate = this.closeCustomFormatter(this.endDate)
		},
		async createReport() {
			const userInput = {
				beginDate: this.beginDate,
				endDate: this.endDate
			}
			NProgress.start()
			try {
				await schema.validate(userInput, {
					abortEarly: false
				})
				this.validationErrors = {}
				const report = await this.$store.dispatch('job/getReport', {
					beginDate: this.beginDate,
					endDate: this.endDate
				})
				var fileName = 'report.csv'
				let data = '\ufeff' + report
				var blob = new Blob([data], { type: 'text/csv,charset=UTF-8' })
				saveAs(blob, fileName)
				NProgress.done()
			} catch (e) {
				this.validationErrors = getValidationErrors(e)
				console.log(e)
				NProgress.done()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/report.scss';
</style>
